module.exports = __webpack_public_path__ + "img/dycbg_img.ae84fadf.png";